<div class="loading-overlay" *ngIf="isLoading">
  <div style="display: grid; justify-content: center; align-items: center;">

    <p style="color: white;" translate="no">Aguarde...</p>
    <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
    </svg>
  </div>
</div>